import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.tipoPresupuesto.fields.id'),
  },
  {
    name: 'descripcion',
    label: i18n('entities.tipoPresupuesto.fields.descripcion'),
  },
  {
    name: 'habilitado',
    label: i18n('entities.tipoPresupuesto.fields.habilitado'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'presupuestosVinculados',
    label: i18n('entities.tipoPresupuesto.fields.presupuestosVinculados'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.tipoPresupuesto.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.tipoPresupuesto.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
